var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.766 13.83l-3.122-3.122c-.156-.125-.344-.218-.53-.218h-.5a6.51 6.51 0 001.373-3.996C12.987 2.934 10.053 0 6.494 0 2.904 0 0 2.935 0 6.494a6.489 6.489 0 006.494 6.493 6.46 6.46 0 003.996-1.373v.53a.73.73 0 00.218.531l3.091 3.09c.312.313.78.313 1.062 0l.874-.873c.312-.281.312-.75.03-1.062zm-9.272-3.34a3.984 3.984 0 01-3.996-3.996 4.004 4.004 0 013.996-3.996c2.185 0 3.996 1.81 3.996 3.996a4.004 4.004 0 01-3.996 3.996z",
    fill: "#1B130E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchImage);
export default __webpack_public_path__ + "static/media/search-image.55b64cef903ce43cf274f458156bbcf6.svg";
export { ForwardRef as ReactComponent };